import { render, staticRenderFns } from "./StatusCardNameBadge.vue?vue&type=template&id=f751907e&lang=true&"
import script from "./StatusCardNameBadge.vue?vue&type=script&lang=js&"
export * from "./StatusCardNameBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports